import { render, staticRenderFns } from "./CommensHead.vue?vue&type=template&id=92e67b24"
import script from "./CommensHead.vue?vue&type=script&lang=js"
export * from "./CommensHead.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports